import { __awaiter, __generator } from "tslib";
export var trackingLoader = function () { return __awaiter(void 0, void 0, void 0, function () {
    var thirdParty, internal, _a, injectImpressionTracking, matchTracking, matchedTracking;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                thirdParty = window.ADAPT.thirdPartyTracking;
                internal = window.ADAPT.internalTracking;
                if (thirdParty === undefined && internal === undefined) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, import(
                    /* webpackChunkName: "tracking" */ './universalTracking')];
            case 1:
                _a = _b.sent(), injectImpressionTracking = _a.injectImpressionTracking, matchTracking = _a.matchTracking;
                if (thirdParty) {
                    matchedTracking = matchTracking(thirdParty);
                    injectImpressionTracking(matchedTracking);
                    window.ADAPT.thirdPartyTracking = matchedTracking;
                }
                if (internal) {
                    injectImpressionTracking(internal);
                }
                return [2 /*return*/];
        }
    });
}); };
